<template>
  <modal name="suggestion-modal"
         @closed="$emit('updateComparisonData')"
         @before-close="beforeClose"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Գնային առաջարկ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('suggestion-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 95%">
      <div class="row">
        <div class="col-12">
          <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
            <thead>
                <tr>
                  <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Ընթացակարգի ծածկագիր</span>
                      </div>
                      <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
                  </th>
                  <th tabindex="0" title="" class="VueTables__sortable ">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Պատվիրատու</span>
                      </div>
                  </th>
                  <!-- <th tabindex="0" title="" class="VueTables__sortable ">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Պատվիրատուի հեռախոսահամար</span>
                      </div>
                  </th> -->
                  <th tabindex="0" title="" class="VueTables__sortable ">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Վերջնաժամկետ</span>
                      </div>
                  </th>
                  <th tabindex="0" title="" class="VueTables__sortable ">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Հաղթողին որոշելու կարգ</span>
                      </div>
                  </th>
                  <template v-if="organize.type === 'itender'">
                    <th tabindex="0" title="" class="VueTables__sortable ">
                        <div class="row justify-content-center">
                          <span class="VueTables__heading">Գործընթացի տեսակը</span>
                        </div>
                    </th>
                    <!-- <th tabindex="0" title="" class="VueTables__sortable ">
                        <div class="row justify-content-center">
                          <span class="VueTables__heading">Գների համեմատումը</span>
                        </div>
                    </th> -->
                    <th tabindex="0" title="" class="VueTables__sortable ">
                        <div class="row justify-content-center">
                          <span class="VueTables__heading">Մրցույթի տեսակ</span>
                        </div>
                    </th>
                    <th tabindex="0" title="" class="VueTables__sortable ">
                        <div class="row justify-content-center">
                          <span class="VueTables__heading">Կատարման վերջնաժամկետ</span>
                        </div>
                    </th>
                  </template>
                </tr>
            </thead>
            <tbody>
                <tr class="VueTables__row ">
                  <td tabindex="0" class="">{{organize.code}}</td>
                  <td tabindex="0" class="">{{customer_name}}</td>
                  <!-- <td tabindex="0" class="">{{client.phone}}</td> -->
                  <td tabindex="0" class="">{{organize.finish_date}}</td>
                  <td tabindex="0" class="">{{organize.winner_by_lots ? 'Ըստ չափաբաժինների' : 'Ըստ ընդհանուր գնի' }}</td>
                  <template v-if="organize.type === 'itender'">
                    <td tabindex="0" class="">{{organize.itender_type === 'survey' ? 'Հարցում (շուկայի ուսումնասիրություն)' : 'Տենդեր'}}</td>
                    <!-- <td tabindex="0" class="">{{client.vat_payer ? 'Առանց ԱԱՀ' : 'Հատուցման ընդհանուր գումարներով'}}</td> -->
                    <td tabindex="0" class="">{{purchaseTypesForItenderLongNames[organize.organize_rows[0].type]}}</td>
                    <td tabindex="0" class="">{{organize.implementation_deadline}}</td>
                  </template>
                </tr>
            </tbody>
          </table>
        </div>
        <div v-if="isItender" class="col-12">
          <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
            <thead>
                <tr>
                  <th colspan="3" tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Մատակարարումը</span>
                      </div>
                      <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
                  </th>
                </tr>
            </thead>
            <tbody>
                <tr class="VueTables__row ">
                  <td tabindex="0" class="">Հասցե՝ {{organize.shipping_address}}</td>
                  <td tabindex="0" class="">Պատվերը ստանալուց՝ {{organize.purchase_schedule}} աշխատանքային օրվա ընթացքում</td>
                  <td tabindex="0" class="">{{getDeliveryType(organize.delivery_type)}}</td>
                </tr>
            </tbody>
          </table>
        </div>
        <div v-if="isItender && organize.payment_schedule_text !== ''" class="col-12">
          <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
            <thead>
                <tr>
                  <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                      <div class="row justify-content-center">
                        <span class="VueTables__heading">Վճարումը</span>
                      </div>
                      <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
                  </th>
                </tr>
            </thead>
            <tbody>
                <tr class="VueTables__row">
                  <td colspan="" tabindex="0" class="">
                    {{organize.payment_schedule_text}}
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 my-2">
          <span v-if="organize.other_requirements !== ''" class="mr-3">Այլ պահանջներ՝ <span class="text-primary font-weight-bold">{{organize.other_requirements}}</span></span>
          <label class="btn btn-primary" :class="uploadFileLoading && 'disabled'">
            <font-awesome-icon icon="file-upload" class="mr-2"/>
            <span>Կցել փաստաթղթեր</span>
            <input @change="handleUploadFile" type="file" hidden>
            <span v-if="uploadFileLoading" class="ml-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </label>
          <br/>
          <div class="btn-group" v-if="additionalFile">
            <a :href="additionalFile" download target="_blank" class="btn btn-primary">
              {{additionalFile.split('/')[additionalFile.split('/').length - 1]}}
            </a>
            <button :disabled="isResponded" class="btn btn-danger" @click="deleteAdditionalFile">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <v-client-table class="suggestion-table" :columns="columns" v-model="data" :options="options">
        <div slot="id" class="d-flex justify-content-center" slot-scope="{row}">
          {{ row.view_id }}
        </div>
        <div slot="product" class="d-flex justify-content-center" slot-scope="{row}">
          {{ row.cpv_name }}
        </div>
        <div slot="cpv" class="d-flex justify-content-center" slot-scope="{row}">
          {{ row.cpv_code }}
        </div>
        <div slot="unit" class="d-flex justify-content-center" slot-scope="{row}">
          {{ row.cpv_unit }}
        </div>
        <div slot="specifications" class="d-flex justify-content-center" slot-scope="{row}">
           <template v-if="row.specifications">
            <div v-if="row.specifications.length <= 75">{{ row.specifications }}</div>
            <div v-else>
              {{ row.specifications.substring(0, 75) + '...'}}
              <span @click.stop="()=>$modal.show('row-specification-modal', {...row})" class="text-primary" style="cursor: pointer">
                  տեսնել ավելին
              </span>
            </div>
           </template>
        </div>
        <div slot="specification" class="d-flex justify-content-center p-0" slot-scope="{row, index}">
          <template v-if="organize.winner_by_lots || index !== data.length">
            <div class="row p-0 w-100 m-0 justify-content-center">
                <textarea
                  v-model.number="data[index-1].specification"
                  class="form-control w-100 m-0"
                />
            </div>
          </template>
        </div>
        <div slot="priceUnit" class="d-flex justify-content-center" slot-scope="{row, index}">
          <template v-if="organize.winner_by_lots || index !== data.length">
            {{ row.unit_amount}} դր.
          </template>
        </div>
         <div slot="priceAll" class="d-flex justify-content-center" slot-scope="{row, index}">
          <template v-if="organize.winner_by_lots || index !== data.length">
            {{ row.unit_amount * row.count }} դր.
          </template>
        </div>
        <div slot="price" class="d-flex justify-content-center p-0" slot-scope="{row, index}">
          <template v-if="organize.winner_by_lots || index !== data.length">
            <div class="row p-0 w-100 m-0 justify-content-center">
              <input 
                v-model.number="data[index-1].value"
                @input="calculateByTotal(index-1)"
                v-positive-only.none-zero
                type="text"
                min="1"
                :class="{'border-primary': focusedLotFields.row === index && _.includes(focusedLotFields.activeFields, '1')}"
                class="col-12 form-control w-100 m-0"
              >
              <span v-if="data[index-1].overall > row.unit_amount * row.count"
                    class="text-danger mb-0" style="font-size: 0.6rem">
                    գերազանցում է նախահաշվային գինը
              </span>
            </div>
          </template>
          <template v-else>
            {{ getTotalPrice() }}
          </template>
        </div>
        <div slot="vat" class="d-flex justify-content-center" slot-scope="{row, index}">
          <template v-if="organize.winner_by_lots || index !== data.length">
            <div class="row px-2">
              <div class="col-12">
                <input
                  v-model="data[index-1].is_with_vat"
                  :true-value="1"
                  :false-value="0"
                  :data-index="index-1"
                  @change="handleVatSelect(data[index-1].is_with_vat, index-1)"
                  type="checkbox"
                >
                  <span class="m-2">{{data[index-1].vat}}</span>
              </div>
            </div>
          </template>
          <template v-else>
            {{ getTotalVat() }}
          </template>
        </div>
        <div slot="total" class="d-flex justify-content-center" slot-scope="{row, index}">
          <template v-if="organize.winner_by_lots || index !== data.length">
            <div class="d-flex flex-row-reverse justify-content-between align-items-center">
              {{data[index-1].overall}}
            </div>
          </template>
          <template v-else>
            {{ getTotalTotalPrice() }}
          </template>
        </div>
      </v-client-table>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <div v-tooltip="isResponded?'Դուք արդեն ներկայացրել եք առաջարկ տվյալ ընթացակարգի համար':''" class="float-right" >
        <button :disabled="isResponded" @click="send" type="button" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
            Ներկայացնել առաջարկը
        </button>
      </div>
      <div v-tooltip="isResponded?'Դուք արդեն ներկայացրել եք առաջարկ տվյալ ընթացակարգի համար':''" class="float-right" >
        <button :disabled="isResponded" @click="save" type="button" class="btn btn-info waves-effect waves-light float-right mr-3" data-toggle="modal" data-animation="bounce">
            Պահպանել սևագիրը
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import purchaseTypesForItenderLongNames from '@/mixins/purchaseTypes'

export default {
  name: 'SuggestionModal',
  mixins: [purchaseTypesForItenderLongNames],
  data () {
    return {
      isSetEqual: false,
      isSuccess: true,
      isNewSuggestion: true,
      isResponded: false,
      isNewParticipant: true,
      uploadFileLoading: false,
      isItender: false,
      uploadedFileName: '',
      additionalFile: '',
      organize_type: '',
      customer_name: '',
      lotsWithError: [],
      participant: {},
      columns: ['id', 'product', 'cpv', 'count', 'unit', 'specifications', 'priceUnit', 'priceAll', 'price', 'vat', 'total'],
      organize: {},
      data: [],
      attachedLotsForParticipant: [],
      focusedLotFields: {},
      lotsWithVatLength: 0,
      sugesstion: {},
      options: {
        sortable: [],
        perPage: 1000,
        perPageValues: [],
        columnsDropdown: false,
        filterByColumn: false,
        dateFormat: "YYYY-mm-dd",
        headings: {
          id: 'Չ/Հ',
          product: 'Գնման առարկա',
          cpv: 'CPV կոդ',
          count: 'Քանակ',
          unit: 'Չափման միավոր',
          specification: 'Ներկայացվող տեխնիկական բնութագիր',
          specifications: 'Տեխնիկական բնութագիր',
          price: 'Արժեք',
          priceUnit: 'Նախահաշվային միավոր գին',
          priceAll: 'Նախահաշվային ընդհանուր գին',
          vat: 'ԱԱՀ',
          total: 'Ընդամենը'
        },
        filterable: []
      },
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    handleUploadFile(event){
      const file = event.target.files[0]
      if(file.size < 100000000){
        this.uploadFileLoading = true;
        const uploadedFile = file;
        const formData = new FormData();
        formData.append('file', uploadedFile);
        this.$client.post(`suggestions/uploadAdditionalFile/${this.currSuggestionId}`, formData).then(({data}) => {
          this.additionalFile = data.additional_file
          if(data){
            this.uploadFileLoading = false;
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Հաջողությամբ հաստատված է'
            })
          }
        })
        this.uploadedFileName = file.name;
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Ընտրված ֆայլի առավելագույն ծավալը պետք է լինի 10ՄԲ'
        })
      }
    },
    getDeliveryType(type){
      switch (type) {
        case 'without_delivery':
          return 'Առանց առաքման';
        case 'by_participant_resources_participant':
          return 'Առաքումով՝ մասնակցի կողմից, մասնակցի միջոցներով';
        case 'by_participant_resources_organizer':
          return 'Առաքումով՝ մասնակցի կողմից, կազմակերպիչի միջոցներով';
        case 'by_organizer_resources_participant':
          return 'Առաքումով՝ կազմակերպիչի կողմից, մասնակցի միջոցներով';
        default:
          break;
      } 
    },
    async send(){
      var isValid = true;
      var isValidAllFields = true;
      if(!this.organize.winner_by_lots){
        this.data.forEach((lot, index) => {
          if(index !== this.data.length-1){
            if(!lot.overall || !lot.specification){
              isValid = false
            }
          }
        })
      }
      const changedRows = this.data.filter((item) => item.overall);
      if(changedRows.length === 0){
        isValid = false
      } else {
        changedRows.forEach((lot, index) => {
          if(!lot.overall || !lot.specification){
            isValidAllFields = false
          }
        })
      }
      if(isValid){
        if(isValidAllFields){
          await this.checkEqualPrice('send');
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Անհրաժեշտ է լրացնել «Ներկայացվող տեխնիկական բնութագիր» դաշտը',
            text: 'Կրկին փորձեք!',
          })
        }
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Անհրաժեշտ է ներակայցնել գնային առաջարկ բոլոր չափաբաժինների համար',
          text: 'Կրկին փորձեք!',
        })
      }
    },
    async save(){
      await this.checkEqualPrice('save');
    },
    async createSuggestion(action){
      if(action === 'send'){
        if(this.isNewSuggestion){
          const requestData = {
            organize_id: this.organize.id,
            client_id: this.organize.customer_id,
            provider_id: this.me.id,
            is_signature: 0,
            is_itender:  this.organize_type === 'itender',
            responded: 1,
          };
          await this.$client.post('suggestions/create', requestData).then(async({data}) => {
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          })
        } else {
          await this.$store.dispatch('suggestions/update', {id: this.currSuggestionId, data: { is_signature: 0, responded: 1 }}).then(async (response) => {
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          })
        }
      } else {
        if(this.isNewSuggestion){
          const requestData = {
            organize_id: this.organize.id,
            client_id: this.organize.customer_id,
            provider_id: this.me.id,
            is_signature: 1,
            is_itender:  this.organize_type === 'itender',
            responded: 0,
          };
          await this.$client.post('suggestions/create', requestData).then(async({data}) => {
            if(data.status){
              await this.checkEqualPrice();
            }
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          })
        } else {
          await this.$store.dispatch('suggestions/update', {id: this.currSuggestionId, data: { is_signature: 1 }}).then(async (response) => {
            if(response) {
              await this.checkEqualPrice();
            }
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          })
        }
      }
    },
    async checkEqualPrice(action){
      this.lotsWithError = [];
      this.isSetEqual = false;
      const changedRows = this.data.filter((item) => item.overall).length
      await this.data.filter((item) => item.overall).forEach(async(row, index) => {
        if(this.organize.winner_by_lots){
          this.$client.post(`participant-row/checkEqualPrice/${row.id}`, {price: row.overall}).then(async({data}) => {
            if(data.status){
              this.lotsWithError.push(row)
              this.isSetEqual = true
            }
            if(index === changedRows-1){
              await this.showErrors(action)
            }
          })
        } else {
          this.$client.post(`participant-row/checkEqualPrice/${row.id}`, {total_price: this.getTotalTotalPrice()}).then(async({data}) => {
            if(data.status){
              row.error = true
              this.isSetEqual = true
            }
            if(index === changedRows-1){
              await this.showErrors(action)
            }
          })
        }
      })
    },
    async updatePrices(){
        const lots = []
        this.data.forEach((row) => {
          if(row.overall){
            const requestObj = {
              participant_id: this.me.id,
              is_satisfactory: 1,
              organize_row_id: row.id,
              overall: row.overall, 
              total_price: row.value, 
              specification: row.specification,
              vat: row.vat,
              total: !this.organize.winner_by_lots ? this.getTotalTotalPrice() : 0 
            }
            lots.push(requestObj)
          }
        })
        const participantGroupRequestData = Object.assign({
          organize_id: this.organize.id,
          is_cooperation: false,
          is_agency_agreement: false,
          user_id: this.me.id,
        }, {
          lots: lots,
          participant: [
            {
              is_physical_person: Boolean(this.me.organisation[0].id_card_number),
              id_card_number: this.me.organisation[0].id_card_number,
              is_docs_satisfactory: true,
              price_offer_exists: true,
              tin: this.me.organisation[0].tin,
              date_of_submission: this.currentDate(),
              email: this.me.email,
              phone: this.me.organisation[0].phone,
              first_name: {
                hy: this.me.organisation[0].translations.name.hy,
                ru: this.me.organisation[0].translations.name.ru
              },
              last_name: {
                hy: '',
                ru: ''
              },
              middle_name: {
                hy: '',
                ru: ''
              },
              address: {
                hy: `${this.me.organisation[0].translations.region.hy || ''} ${this.me.organisation[0].translations.city.hy || ''}  ${this.me.organisation[0].translations.address.hy || ''}`,
                ru: `${this.me.organisation[0].translations.region.ru || ''} ${this.me.organisation[0].translations.city.ru || ''}  ${this.me.organisation[0].translations.address.ru || ''}`,
              },
              name: {
                hy: `${this.me.organisation[0].translations.company_type.hy ? `«${this.me.organisation[0].translations.name.hy}» ${this.me.organisation[0].translations.company_type.hy}` : this.me.organisation[0].translations.name.hy}`,
                ru: `${this.me.organisation[0].translations.company_type.ru ? `«${this.me.organisation[0].translations.name.ru}» ${this.me.organisation[0].translations.company_type.ru}` : this.me.organisation[0].translations.name.hy}`,
              },
            }
          ],
        })
      const requestMethod = this.isNewParticipant ? 'post' : 'put'
      const url = this.isNewParticipant ? 'participant-group' : `participant-group/${this.participant.id}`
      this.$client[requestMethod](url, participantGroupRequestData).then(async({data}) => {
        // const groupId = this.participant.id ? this.participant.id : data
        // this.$client.post(`participant-group/addPersonalInfo/${groupId}`, {
        //   bank: this.me.organisation[0].translations.bank_name.hy,
        //   account_number:  this.me.organisation[0].bank_account, 
        //   director: this.me.organisation[0].translations.director_name.hy
        // })
      }).catch(e => {
        this.isSaving = false
      })
    },
    async showErrors(action){
      if(this.isSetEqual){
        this.$notify({
          group: 'foo',
          type: 'error',
          title: `Առկա է գնային առաջարկի կրկնություն ${this.lotsWithError.length 
            ? `${this.lotsWithError.map(lot => ` ${lot.view_id}${lot.view_id === 1?'-ին':'-րդ'}`)} ${this.lotsWithError.length > 1?'չափաբաժինների':'չափաբաժնի'} համար` : ''}`,
          text: 'Խնդրում ենք փոխել ներկայացվող գինը և կրկին փորձել',
          duration: -1,
        })
      } else if(this.isSuccess){
        this.$notify({
          group: 'foo',
          type: 'success',
          text: 'Հաջողությամբ պահպանված է'
        })
        await this.createSuggestion(action)
        await this.updatePrices()
        this.$modal.hide('suggestion-modal')
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        })
      }
    },
    currentDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      return yyyy + '-' + mm + '-' + dd;
    },
    calculateByTotal(index) {
      const lot = this.data[index]
      lot.vat = lot.is_with_vat && lot.value ? Number((lot.value * 0.2).toFixed(2)) : 0
      lot.overall = lot.value ? lot.value + lot.vat : 0
      this.$set(this.data, index, lot)
    },
    calculateByVat(index) {
      const lot = this.data[index]
      lot.overall = lot.is_with_vat ? lot.value + lot.vat : lot.value
      this.$set(this.data, index, lot)
    },
    handleVatSelect(selected, index) {
      // const nextVal = !event.target.value
      selected ? this.lotsWithVatLength++ : this.lotsWithVatLength--
      this.calculateByTotal(index)
    },
    getTotalPrice(){
      var totalValue = 0
      this.data.forEach((lot, index) => {
        if(index !== this.data.length-1){
          totalValue = totalValue + lot.value
        }
      })
      return isNaN(totalValue) ? 0 : totalValue
    },
    getTotalVat(){
      var totalVat = 0
      this.data.forEach((lot, index) => {
        if(index !== this.data.length-1){
          totalVat = totalVat + lot.vat
        }
      })
      return isNaN(totalVat) ? 0 : totalVat
    },
    getTotalTotalPrice(){
      var totalOverall = 0
      this.data.forEach((lot, index) => {
        if(index !== this.data.length-1){
          totalOverall = totalOverall + lot.overall
        }
      })
      return isNaN(totalOverall) ? 0 : totalOverall
    },
    beforeClose(){
      this.isNewSuggestion = true;
      this.isResponded = false;
      // this.resetComponent()
      if(!this.organize.winner_by_lots){
        this.data.pop()
      }
    },
    beforeOpen({params}) {
      this.resetComponent = params.resetComponent
      this.organize = params.organize
      this.organize_type = params.organize_type
      this.customer_name = params.customer_name
      this.isItender = params.organize.type === 'itender'
      this.$client.get(`suggestions/getByOrganizeId/${this.organize.id}`).then(({data}) => {
        if(data){
          if(data.participant){
            this.participant = data.participant
            this.isNewParticipant = false;
          }
          this.isNewSuggestion = false;
          this.currSuggestionId = data.id;
          this.isResponded = Boolean(data.responded);
        }
      })
      this.cleanData = this.organize.organize_rows
      this.data = this.organize.organize_rows
      if(!this.organize.winner_by_lots){
        if(this.data[this.data.length-1].is_total !== true){
          this.data.push({
            cpv_name: 'Ընդամենը',
            is_total: true
          })
        }
      }
      this.data.forEach((lot) => {
        if(lot.offers){
          const currUserOffer = lot.offers.find(item => item.participant_id ===  this.me.id);
          if(currUserOffer){
            lot.value = currUserOffer.value
            lot.overall = currUserOffer.cost
            lot.specification = currUserOffer.specification
            lot.vat = currUserOffer.vat
            lot.is_with_vat = currUserOffer.vat ? 1 : 0
          }
        }
      })
      this.columns = ['id', 'product', 'cpv', 'count', 'unit', 'specifications', 'priceUnit', 'priceAll', 'specification', 'price', 'vat', 'total'];
    },
    handleLotInputsFocus(event, details) {
      // eslint-disable-next-line eqeqeq
      if(event.target.value == 0) {
        event.target.select()
      }
      this.focusedLotFields = details
    },
  }
}
</script>
<style>
.suggestion-table td{
  padding: 5px 2px;
}
</style>
<style scoped>
  /deep/ .page-item {
      display: none;
  }
  /deep/ .vm--modal {
    top: 3rem !important;
    left: unset !important;
    width: 80% !important;
    /* height: auto !important; */
    margin: auto;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .searchItem:hover {
    background-color: #1e7bb7;
    color: #fff;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

